export type ProductDetailInfo = {
  product: ProductDetail;
  categories: Category[];
  reviewStatic: ReviewStatic;
  shippingPolicy: ShippingPolicy;
  relatedCollections: RelatedCollections;
};

export type ProductDetail = {
  productId: string;
  sku: string;
  name: string;
  brand: string;
  productLink: string;
  productImageUrls: string[];
  category: string[];
  modifiedAt: string;
  size: string;
  pack: string;
  originalPrice: number;
  currency: string;
  type: string;
  status: string;
  description: string;
  additionalPrices: AdditionalPrice[];
  salePrice: number;
};

export interface AdditionalPrice {
  currency: string;
  originalPrice: number;
  salesPrice: number;
}

export interface Category {
  termId: number;
  name: string;
  slug: string;
  description: string;
}

export interface ReviewStatic {
  productId: string;
  averageRate: number;
  totalReviews: number;
}

export interface ShippingPolicy {
  currency: string;
  minDeliveryDays: number;
  maxDeliveryDays: number;
  shippingFee: number;
  freeShippingThreshold: number;
}

export interface RelatedCollections {
  brand: Brand;
  category: Category;
}

export interface Brand {
  termId: number;
  name: string;
  slug: string;
  description: string;
  brandImageUrl: string;
}
